import {createEntityAdapter, Dictionary, EntityAdapter, EntityState} from '@ngrx/entity';
import {ActionReducer, createReducer, on} from '@ngrx/store';
import {createFeature, createSelector} from '@ngrx/store';
import {VisitPlanAccountModel} from "../../../models/visit-plan-account.model";
import {
  VisitPlanAccountActions,
  VisitPlanAccountAPiActions,
  VisitPlanAccountChannelActions
} from "./visit-plan-account.actions";
import {ServicesActions} from "../../../../deliveries/angular/state/services.action";
import {VisitPlanAccountAnalysisModel} from "../../../models/visit-plan-account-analysis.model";
import {uniqBy} from "lodash";

export interface VisitPlanAccountState extends EntityState<VisitPlanAccountModel> {
  cursor: string;
  isLoading: boolean;
  initialized: boolean;
  isNotSynced: boolean;
  visitPlanAccountAnalysis: VisitPlanAccountAnalysisModel[];
}

const adapter: EntityAdapter<VisitPlanAccountModel> = createEntityAdapter<VisitPlanAccountModel>({
  selectId: (visitPlanAccount: VisitPlanAccountModel) => visitPlanAccount.accountReference.id
});

const initialState: VisitPlanAccountState = adapter.getInitialState({
  cursor: null,
  isLoading: false,
  initialized: false,
  isNotSynced: false,
  visitPlanAccountAnalysis: []
});

const reducer: ActionReducer<VisitPlanAccountState> = createReducer(
  initialState,

  // on(
  //   VisitPlanAccountChannelActions.notificationReceived,
  //   (state, {notification}) => {
  //     const visitPlanAccount = Object.values(state.entities).find(
  //       vpa => vpa.accountReference.id === notification.accountId
  //     );
  //
  //     if (!visitPlanAccount) {
  //       return state;
  //     }
  //
  //     const visitPlanAccountCellIndex = visitPlanAccount.visitSlots.findIndex(
  //       cell => cell.id === notification.id
  //     );
  //
  //     if (visitPlanAccountCellIndex === -1) {
  //       return state;
  //     }
  //
  //     const currentCell = visitPlanAccount.visitSlots[visitPlanAccountCellIndex];
  //
  //     if (currentCell?.updatedAt < notification.updatedAt) {
  //       const updatedVisitSlots = visitPlanAccount.visitSlots.map((cell, index) =>
  //         index === visitPlanAccountCellIndex ? {...notification} : cell
  //       );
  //
  //       const updatedVisitPlanAccount = {
  //         ...visitPlanAccount,
  //         visitSlots: updatedVisitSlots,
  //       };
  //
  //       return adapter.setOne(updatedVisitPlanAccount, state);
  //     }
  //
  //     return state;
  //   }
  // ),
  on(
    VisitPlanAccountChannelActions.notificationReceived,
    (state, { notification }) => {
      const visitPlanAccount = Object.values(state.entities).find(
        vpa => vpa.accountReference.id === notification.accountId
      );

      if (!visitPlanAccount) return state;

      const visitPlanAccountCellIndex = visitPlanAccount.visitSlots.findIndex(
        cell => cell.id === notification.id
      );

      if (visitPlanAccountCellIndex === -1) return state;

      const currentCell = visitPlanAccount.visitSlots[visitPlanAccountCellIndex];

      if (currentCell?.updatedAt < notification.updatedAt) {
        const updatedVisitSlots = visitPlanAccount.visitSlots.map((cell, index) => {
          if (index !== visitPlanAccountCellIndex) return cell;

          return {
            ...cell,
            ...notification,
            calls: notification.calls ?? cell.calls ?? [],
          };
        });

        const updatedVisitPlanAccount = {
          ...visitPlanAccount,
          visitSlots: updatedVisitSlots,
        };

        return adapter.setOne(updatedVisitPlanAccount, state);
      }

      return state;
    }
  ),

  on(VisitPlanAccountAPiActions.getVisitPlanAccounts, (state) => ({...state, isLoading: true})),

  on(VisitPlanAccountAPiActions.getVisitPlanAccountsSuccess, (state, {visitPlanAccounts, cursor}) => {
    return adapter.setMany(visitPlanAccounts,
      {
        ...state,
        cursor: cursor,
        isLoading: false,
        initialized: true
      })
  }),

  // on(
  //   VisitPlanAccountAPiActions.getVisitPlanAccountsAnalysisSuccess,
  //   (state, {visitPlanAccountsAnalysis}) => {
  //     const accountsToUpdate: VisitPlanAccountModel[] = [];
  //
  //     for (const visitPlanAccountAnalysis of visitPlanAccountsAnalysis) {
  //       const account = state.entities[visitPlanAccountAnalysis.accountId];
  //       if (!account) continue;
  //
  //       let updated = false;
  //
  //       const updatedSlots = account.visitSlots?.map(slot => {
  //         const slotAnalysis = visitPlanAccountAnalysis.slots?.find(s => s.slotId === slot.id);
  //         if (!slotAnalysis) return slot; // No analysis for this slot
  //
  //         const updatedCalls = slot.calls?.map(call => {
  //           const callAnalysis = slotAnalysis.calls.find(ca => ca.callId === call.id);
  //           if (!callAnalysis) return call; // No matching analysis
  //           updated = true;
  //
  //           // Merge analysis data except `callId`
  //           const {callId, ...rest} = callAnalysis;
  //           return {...call, ...rest};
  //         }) ?? slot.calls;
  //
  //         return {...slot, calls: updatedCalls};
  //       }) ?? account.visitSlots;
  //
  //       // Handle visitSlotTrackers if they exist
  //       const updatedTrackers = account.visitSlotTrackers?.map(tracker => {
  //         const slotAnalysis = visitPlanAccountAnalysis.slots.find(s => s.slotId === tracker.id);
  //         if (!slotAnalysis) return tracker;
  //
  //         const merged = {
  //           ...tracker,
  //           slotAnalysis
  //         };
  //         updated = true;
  //         return merged;
  //       }) ?? account.visitSlotTrackers;
  //
  //       if (updated) {
  //         accountsToUpdate.push({
  //           ...account,
  //           visitSlots: updatedSlots,
  //           visitSlotTrackers: updatedTrackers,
  //         });
  //       }
  //     }
  //
  //     return adapter.setMany(accountsToUpdate, state);
  //   }
  // ),

  on(VisitPlanAccountAPiActions.getVisitPlanAccountsAnalysisSuccess, (state, {visitPlanAccountsAnalysis}) =>
    ({
      ...state,
      visitPlanAccountAnalysis: uniqBy([...visitPlanAccountsAnalysis, ...state.visitPlanAccountAnalysis], 'accountId')
    })),


  on(VisitPlanAccountAPiActions.getVisitPlanAccountsFailure, (state) => ({...state, isLoading: false})),

  on(VisitPlanAccountAPiActions.deleteCallsFromCell, (state) => state),

  on(
    VisitPlanAccountAPiActions.deleteCallsFromCellSuccess,
    (state, {visitPlanCell}) => {
      // Find the account by accountId
      const visitPlanAccount = Object.values(state.entities).find(
        vpa => vpa.accountReference.id === visitPlanCell.accountId
      );

      if (!visitPlanAccount) return state;

      const oldCell = visitPlanAccount.visitSlots.find(c => c.id === visitPlanCell.id);

      if (!oldCell) return state;

      const deletedCallIds = oldCell.calls
        .filter(oldCall => !visitPlanCell.calls.some(newCall => newCall.id === oldCall.id))
        .map(c => c.id);

      const deletedCallIdsSet = new Set(deletedCallIds);

      const updatedVisitSlots = visitPlanAccount.visitSlots.map(cell =>
        cell.id === visitPlanCell.id ? {...visitPlanCell} : cell
      );

      const updatedVisitSlotTrackers = visitPlanAccount.visitSlotTrackers?.filter(
        tracker => !tracker.editedCallIds?.some(id => deletedCallIdsSet.has(id))
      );

      const updatedVisitPlanAccount = {
        ...visitPlanAccount,
        visitSlots: updatedVisitSlots,
        visitSlotTrackers: updatedVisitSlotTrackers
      };

      return adapter.setOne(updatedVisitPlanAccount, state);
    }
  ),

  on(VisitPlanAccountAPiActions.deleteCallsFromCellFailure, (state) => state),


  on(
    VisitPlanAccountAPiActions.createCallSuccess,
    (state, {visitPlanCell}) => {
      const visitPlanAccount = Object.values(state.entities).find(
        vpa => vpa.accountReference.id === visitPlanCell.accountId
      );

      if (!visitPlanAccount) return state;

      const visitPlanAccountCellIndex = visitPlanAccount.visitSlots.findIndex(
        cell => cell.id === visitPlanCell.id
      );

      if (visitPlanAccountCellIndex === -1) return state;

      const oldCell = visitPlanAccount.visitSlots[visitPlanAccountCellIndex];
      const newCell = visitPlanCell;

      const oldCallIds = oldCell.calls.map(c => c.id);
      const newCalls = newCell.calls.filter(c => !oldCallIds.includes(c.id));

      const updatedVisitSlots = visitPlanAccount.visitSlots.map((cell, index) =>
        index === visitPlanAccountCellIndex ? {...newCell} : cell
      );

      const updatedVisitSlotTrackers = visitPlanAccount.visitSlotTrackers?.map(
        tracker => {
          if (tracker.id === newCell.id && newCalls.length > 0) {
            return {
              ...tracker,
              entity: {
                ...tracker.entity,
                calls: [...(tracker.entity.calls || []), ...newCalls]
              }
            };
          }
          return tracker;
        }
      ) ?? [];

      const updatedVisitPlanAccount = {
        ...visitPlanAccount,
        visitSlots: updatedVisitSlots,
        visitSlotTrackers: updatedVisitSlotTrackers,
      };

      return adapter.setOne(updatedVisitPlanAccount, state);
    }
  ),

  on(VisitPlanAccountAPiActions.updateCellTrackerSuccess, (state, { visitPlanCellTracker }) => {
    const visitPlanAccount = state.entities[visitPlanCellTracker.entity.accountId];

    if (!visitPlanAccount) return state;

    const visitSlotTrackers = visitPlanAccount.visitSlotTrackers
      ? [...visitPlanAccount.visitSlotTrackers]
      : [];

    const visitSlotTrackerIndex = visitSlotTrackers.findIndex(
      vst => vst.id === visitPlanCellTracker.id
    );

    if (visitSlotTrackerIndex > -1) {
      visitSlotTrackers[visitSlotTrackerIndex] = visitPlanCellTracker;
    } else {
      visitSlotTrackers.push(visitPlanCellTracker);
    }

    const updatedVisitPlanAccount = {
      ...visitPlanAccount,
      visitSlotTrackers
    };

    return adapter.setOne(updatedVisitPlanAccount, state);
  }),

  // on(VisitPlanAccountAPiActions.updateCellTrackerSuccess, (state, {visitPlanCellTracker}) => {
  //   // const visitPlanAccount = {...Object.values(state.entities).find(vpa => vpa.accountReference.id === visitPlanCellTracker.entity.accountId)};
  //   //
  //   // const visitSlotTrackers = !!visitPlanAccount.visitSlotTrackers ? [...visitPlanAccount.visitSlotTrackers] : [];
  //
  //   const visitPlanAccount = Object.values(state.entities).find(
  //     vpa => vpa.accountReference.id === visitPlanCellTracker.entity.accountId
  //   );
  //
  //   if (!visitPlanAccount) return state;
  //
  //   const visitSlotTrackers = visitPlanAccount.visitSlotTrackers ? [...visitPlanAccount.visitSlotTrackers] : [];
  //
  //
  //   const visitSlotTrackerIndex = visitSlotTrackers.findIndex((vst) => vst.id === visitPlanCellTracker.id);
  //
  //   if (visitSlotTrackerIndex > -1) {
  //     visitSlotTrackers[visitSlotTrackerIndex] = visitPlanCellTracker;
  //   } else {
  //     visitSlotTrackers.push(visitPlanCellTracker);
  //   }
  //
  //   const updatedVisitPlanAccount = {
  //     ...visitPlanAccount,
  //     visitSlotTrackers: visitSlotTrackers
  //   }
  //
  //   return adapter.setOne(updatedVisitPlanAccount, state);
  // }),

  on(VisitPlanAccountAPiActions.updateCallsTimeWindowSuccess, (state, {visitPlanCells}) => {
    const accountsMap: Record<string, VisitPlanAccountModel> = {};

    visitPlanCells.forEach(cell => {
      const account = state.entities[cell.accountId];
      if (!account) return;

      const accountToUpdate = accountsMap[cell.accountId] || account;

      const updatedCells = accountToUpdate.visitSlots.map(c =>
        c.id === cell.id ? {...c, ...cell} : c
      );

      accountsMap[cell.accountId] = {...accountToUpdate, visitSlots: updatedCells};
    });

    const accountsToUpdate = Object.values(accountsMap);
    return adapter.setMany(accountsToUpdate, state);
  }),

  on(VisitPlanAccountAPiActions.assignCallsToResource, (state) => state),

      on(VisitPlanAccountAPiActions.assignCallsToResourceSuccess, (state, {visitPlanCell}) => {
        const visitPlanAccount = Object.values(state.entities).find(
          vpa => vpa.accountReference.id === visitPlanCell.accountId
        );

        if (!visitPlanAccount) return {...state};

        const oldCell = visitPlanAccount.visitSlots.find(c => c.id === visitPlanCell.id);

        if (!oldCell) return {...state};

        const assignedCallIds = oldCell.calls
          .filter(oldCall => !visitPlanCell.calls.some(newCall => newCall.id === oldCall.id))
          .map(c => c.id);

        const assignedCallIdsSet = new Set(assignedCallIds);

        const updatedVisitSlots = visitPlanAccount.visitSlots.map(cell =>
          cell.id === visitPlanCell.id ? {...visitPlanCell} : cell
        );

        const updatedVisitSlotTrackers = visitPlanAccount.visitSlotTrackers?.filter(
          tracker => !tracker.editedCallIds?.some(id => assignedCallIdsSet.has(id))
        );

        const updatedVisitPlanAccount = {
          ...visitPlanAccount,
          visitSlots: updatedVisitSlots,
          visitSlotTrackers: updatedVisitSlotTrackers
        };

        return adapter.setOne(updatedVisitPlanAccount, {...state});
      }
    ),

  on(VisitPlanAccountAPiActions.assignCallsToResourceFailure, (state) => state),

  on(
    VisitPlanAccountActions.clearCellTrackers,
    (state) => {
      const updatedAccounts = Object.values(state.entities)
        .filter((acc): acc is VisitPlanAccountModel => !!acc)
        .map(acc => ({
          ...acc,
          visitSlotTrackers: undefined,
        }));

      return adapter.setMany(updatedAccounts, state);
    }
  ),

  on(
    VisitPlanAccountAPiActions.discardChangesSuccess,
    (state, {includeIds, excludeIds}) => {
      const accountsToUpdate: VisitPlanAccountModel[] = [];

      Object.values(state.entities).forEach(account => {
        if (!account) return;

        let updatedTrackers = account.visitSlotTrackers ?? [];

        if (includeIds?.length) {
          // Remove only trackers in includeIds
          updatedTrackers = updatedTrackers.filter(tracker => !includeIds.includes(tracker.id));
        } else if (excludeIds?.length) {
          // Keep only trackers in excludeIds
          updatedTrackers = updatedTrackers.filter(tracker => excludeIds.includes(tracker.id));
        } else {
          // Remove all
          updatedTrackers = [];
        }

        if (updatedTrackers.length !== (account.visitSlotTrackers?.length ?? 0)) {
          accountsToUpdate.push({
            ...account,
            visitSlotTrackers: updatedTrackers
          });
        }
      });

      return adapter.setMany(accountsToUpdate, state);
    }
  ),


  on(VisitPlanAccountAPiActions.updateCellTracker, (state) => state),

  on(VisitPlanAccountAPiActions.updateCellTrackerFailure, (state) => state),


  on(VisitPlanAccountAPiActions.submitVisitPlanTracker, (state) => state),

  on(
    VisitPlanAccountAPiActions.submitVisitPlanTrackerSuccess,
    (state, {includeIds, excludeIds}) => {
      const accountsToUpdate: VisitPlanAccountModel[] = [];

      Object.values(state.entities).forEach(account => {
        if (!account?.visitSlotTrackers?.length) return;

        let updatedTrackers = account.visitSlotTrackers;

        if (!includeIds?.length && !excludeIds?.length) {
          updatedTrackers = [];
        } else if (includeIds?.length && !excludeIds?.length) {
          updatedTrackers = account.visitSlotTrackers?.filter(
            tracker => !includeIds.includes(tracker.id)
          );
        } else if (excludeIds?.length) {
          updatedTrackers = account.visitSlotTrackers?.filter(
            tracker => excludeIds.includes(tracker.id)
          );
        }

        if (updatedTrackers.length !== account.visitSlotTrackers?.length) {
          accountsToUpdate.push({
            ...account,
            visitSlotTrackers: updatedTrackers
          });
        }
      });

      return adapter.setMany(accountsToUpdate, state);
    }
  ),

  on(VisitPlanAccountAPiActions.submitVisitPlanTrackerFailure, (state) => state),

  on(VisitPlanAccountActions.removeAll, (state) => adapter.removeAll({...state, initialized: false})),
  on(VisitPlanAccountActions.clearStore, () => ({...initialState})),

  on(VisitPlanAccountAPiActions.syncVisitPlanSuccess, (state) => state)
);

export const visitPlanAccountFeature = createFeature({
  name: 'VisitPlanAccount',
  reducer,
  extraSelectors: ({
                     selectVisitPlanAccountState,
                     selectEntities,
                     selectCursor,
                     selectIsLoading,
                     selectInitialized,
                     selectVisitPlanAccountAnalysis
                   }) => ({
    ...adapter.getSelectors(selectVisitPlanAccountState),
    selectVisitPlanAccounts: () => createSelector(
      selectEntities,
      (entities: Dictionary<VisitPlanAccountModel>) => Object.values(entities),
    ),
    selectVisitPlanAccount: (id: string) => createSelector(
      selectEntities,
      (entities: Dictionary<VisitPlanAccountModel>) => entities[id],
    ),
    selectCursor: () => createSelector(
      selectCursor,
      (cursor) => cursor
    ),
    selectIsLoading: () => createSelector(
      selectIsLoading,
      (isLoading) => isLoading
    ),
    selectInitialized: () => createSelector(
      selectInitialized,
      (initialized) => initialized
    ),
    selectVisitPlanAccountAnalysis: () => createSelector(
      selectVisitPlanAccountAnalysis,
      (selectVisitPlanAccountAnalysis) => {
        return selectVisitPlanAccountAnalysis;
      }
    )
  })
});



